import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {  GridOn  } from "@mui/icons-material";
import {  Link  } from "@mui/material";
import { Header } from '../../types/types';
import { Dispatch } from 'redux';
import TableModal from './TableModal';
import { fetchObjectsToCache } from '../../../../actions/objectCache';
import { extractNoderefsFromFormTableFieldDataJSON } from '../../../../utils/tableAsyncCells';
import { toggleModal } from '../../../ModalTest/actions';

interface TableProps {
  actions: any;
  modal: any;
  header: Header;
  body: { [key: string]: string }[];
  name: string;
  index: number;
}

class TableButton extends (window as any)?.React.PureComponent<TableProps> {

  handleButtonCLick = () => {
    const { actions, body, name } = this.props;
    const index = this.props?.index ? this.props.index : 0;
    actions.fetchObjectsToCache(extractNoderefsFromFormTableFieldDataJSON(body))
      .then(() => actions.toggleModal(true, `${name}TableModal${index}`));
  }

  render() {
    const { modal, header, body, name } = this.props;
    const index = this.props?.index ? this.props.index : 0;
    return (
      <div>
        <Link onClick={() => this.handleButtonCLick()} sx={{display: 'flex',
					alignItems: 'center',
					cursor: 'pointer'}}>
          <GridOn fontSize="small" sx={{marginRight: '5px'}} />
          {window.Alfresco.messages.global['edocat.forms.show-table']}
        </Link>
        {modal?.[`${name}TableModal${index}`]?.isOpen && (
          <TableModal index={index} header={header} body={body} name={name} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return ({
    modal: state?.modal,
    usedObjects: state?.cacheReducer?.usedObjects || {},
  })
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators({ toggleModal, fetchObjectsToCache }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TableButton);
